import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, Image } from 'react-bootstrap'
import Loader from '../components/Loader'
import Message from '../components/Message'
import CommentSection from '../components/CommentSection'
import { listOuterPostDetails } from '../actions/mediaActions'
import AnimatedPage from '../components/AnimatedPage'
import { Helmet } from 'react-helmet-async'
 
function OuterPostScreen({ match }) {
  const dispatch = useDispatch()
  const outerPostDetails = useSelector(state => state.outerPostDetails)
  const { error, loading, outerpost } = outerPostDetails
 
  useEffect(() => {
    dispatch(listOuterPostDetails(match.params.id))
  }, [dispatch, match.params.id])
 
  return (
    <AnimatedPage>
      <div>
        <Helmet>
          <title>{`${outerpost?.title || 'Post'} – Forum RayquazaITA`}</title>
          <meta name="description" content={outerpost?.description ? outerpost.description.slice(0, 155) : 'Leggi questo post sul forum di RayquazaITA.'} />
        </Helmet>
        <Link className="btn btn-light my-3" to="/forum">
          &larr; Torna al forum
        </Link>
 
        {loading ? <Loader />
          : error ? <Message variant="danger">{error}</Message>
          : !outerpost || !outerpost._id ? <Message variant="info">Post non trovato.</Message>
          :
          <Row className="justify-content-center">
            <Col md={7}>
              <h1>{outerpost.title}</h1>
              <p className="text-muted">
                by {outerpost.nickname}
                {outerpost.createdAt && (
                  <> — {new Date(outerpost.createdAt).toLocaleDateString('it-IT')}</>
                )}
              </p>
              {outerpost.image && (
                <Image src={outerpost.image} fluid className="mb-4 rounded" />
              )}
              {outerpost.description && (
                <div style={{ whiteSpace: 'pre-line' }}>
                  {outerpost.description}
                </div>
              )}
            </Col>
            <br></br>
 
            {/* Su desktop (md e oltre) i commenti stanno a destra
                dell'immagine, dove c'era spazio vuoto. Sotto i 768px
                (mobile/tablet stretto) questa colonna scende sotto
                al contenuto, impilata, per via del grid responsive
                di Bootstrap. */}
            <Col md={5}>
            <br></br>
              <CommentSection type="outerpost" id={outerpost._id} />
            </Col>
          </Row>
        }
      </div>
    </AnimatedPage>
  )
}
 
export default OuterPostScreen